require('../stylesheets/main.styl');

// console.log('test');
import './router';
// setTimeout(() => {
//     document.querySelector('video').play();
// });
